import { useMemo, useState } from 'react'
import { EventInput } from '@fullcalendar/core'

import { ButtonV2, Modal, Calendar } from 'components'
import { WeekInterval } from 'components/Calendar/types'

import { ServiceOrderPayload } from 'services/serviceOrderV2'
import { ServiceOrderSchedule } from 'domains/serviceOrders/types'
import {
  ServiceOrderAggregatedQueryResponse,
  SERVICE_ORDER_STATUS_ENUM,
  useGetServiceOrders,
} from 'services/serviceOrder'

import './SOCalendarModal.css'

type ScheduleServiceOrderModalProps = {
  onClose?: () => void
  onSave?: (data: ServiceOrderPayload) => void
  serviceOrder: ServiceOrderSchedule
  readonly?: boolean
}

function SOCalendarModal({
  serviceOrder,
  onClose,
}: ScheduleServiceOrderModalProps): JSX.Element | null {
  const [calendarWeekInterval, setCalendarWeekInterval] =
    useState<WeekInterval>()

  const { data: serviceOrders } = useGetServiceOrders({
    ...(serviceOrder?.technician?.id && {
      technicianIds: [serviceOrder.technician.id],
    }),
    scheduleDateFrom:
      calendarWeekInterval?.startDate && calendarWeekInterval.startDate,
    scheduleDateTo:
      calendarWeekInterval?.endDate && calendarWeekInterval.endDate,
    status: [
      SERVICE_ORDER_STATUS_ENUM.SCHEDULED,
      SERVICE_ORDER_STATUS_ENUM.RESCHEDULED,
      SERVICE_ORDER_STATUS_ENUM.FINISHED,
      SERVICE_ORDER_STATUS_ENUM.IN_PROGRESS,
      SERVICE_ORDER_STATUS_ENUM.IN_VALIDATION,
      SERVICE_ORDER_STATUS_ENUM.REPROVED,
      SERVICE_ORDER_STATUS_ENUM.PAUSED,
      SERVICE_ORDER_STATUS_ENUM.OPEN,
    ],
  })

  const currentServiceOrders: EventInput[] = useMemo(
    () =>
      serviceOrders?.data.map(
        (serviceOrder: ServiceOrderAggregatedQueryResponse) => ({
          id: serviceOrder?.id,
          title: serviceOrder.customer?.name || '',
          tags: serviceOrder.tags,
          allDay: !!serviceOrder?.schedulePeriod,
          start: new Date(serviceOrder?.scheduleDate),
          end:
            !serviceOrder?.schedulePeriod && serviceOrder?.scheduleDate
              ? new Date(serviceOrder?.scheduleDate).setHours(
                  new Date(serviceOrder?.scheduleDate).getHours() + 2,
                )
              : '',
          extendedProps: {
            schedulePeriod: serviceOrder?.schedulePeriod ?? undefined,
            status: serviceOrder?.status,
            number: serviceOrder?.number,
            accountCode: serviceOrder?.account?.code,
            customer: serviceOrder?.customer?.name,
          },
        }),
      ) || [],
    [serviceOrders],
  )

  return (
    <Modal
      size="xl"
      isVisible
      title={'Agenda'}
      className="schedule-service-order-modal"
    >
      <Calendar
        events={currentServiceOrders}
        onChangeWeekInterval={(newInterval) => {
          if (
            calendarWeekInterval?.startDate !== newInterval.startDate ||
            calendarWeekInterval?.endDate !== newInterval.endDate
          ) {
            setCalendarWeekInterval(newInterval)
          }
        }}
      />

      <Modal.Footer>
        <div>
          <ButtonV2 appearance="tertiary" onClick={onClose}>
            Cancelar
          </ButtonV2>
        </div>
      </Modal.Footer>
    </Modal>
  )
}

export default SOCalendarModal
